import { LineItem } from "@made-people/grease-cart";
import { ProductWithVariants } from "@made-people/grease-product";
import { getVariantStockDeliveryData } from "../components/features/delivery-status/get-stock-delivery-data";
import { parseLitWarehouseStatus } from "../services/centra/mappers/utils/parse-lit-warehouse-status";

export const isAllCartItemsOMG = (
  items: LineItem[],
  countryCode: string,
): boolean => {
  for (const item of items) {
    if (item.type !== "product") {
      continue;
    }

    const product = item.product;

    if (product.dataModel !== "with_variants") {
      continue;
    }

    const productWithVariants = product as ProductWithVariants;
    const variant = productWithVariants.variants.find(
      (v) => v.variantId === item.id,
    );

    if (!variant) {
      return false;
    }

    const stockData = getVariantStockDeliveryData(product.base, countryCode);

    if (!stockData) {
      return false;
    }

    const litStatus = parseLitWarehouseStatus(
      stockData.litWarehouseStatus,
      variant.label,
      stockData.tableMapping,
    );

    if (litStatus !== "OMG") {
      return false;
    }
  }

  return true;
};
